// Production
export const env = 'prod';
export const datadogApplicationId = '05e25095-f3a5-4bba-8e11-db4becb6106a'
export const clientToken = 'pubd3a4db9e23491fd6d165f617d82bbdae'
export const backendURL = 'https://backend.greenvibe.io'
